// extracted by mini-css-extract-plugin
export var modal = "_u2-0";
export var table = "_u2-1";